export default __webpack_public_path__ + "static/media/icon_phone_circle.5070543c.svg";